"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeTags = exports.normalizeTag = void 0;
/**
 * Normalizes a single tag for consistency and URL safety
 * - Converts to lowercase
 * - Replaces spaces with hyphens
 * - Removes special characters except hyphens
 * - Collapses multiple hyphens to single
 * - Removes leading/trailing hyphens
 */
const normalizeTag = (tag) => {
    return tag
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/g, "") // Remove special characters except hyphens
        .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
        .replace(/^-|-$/g, ""); // Remove leading/trailing hyphens
};
exports.normalizeTag = normalizeTag;
/**
 * Normalizes an array of tags, removing duplicates and empty values
 * @param tags - Array of tags to normalize (may contain null/undefined)
 * @returns Array of normalized, unique tags
 */
const normalizeTags = (tags) => {
    if (!tags || !Array.isArray(tags))
        return [];
    const normalized = tags
        .filter((tag) => tag !== null && tag !== undefined && typeof tag === "string")
        .map((tag) => (0, exports.normalizeTag)(tag))
        .filter((tag) => tag.length > 0);
    // Remove duplicates using Set
    return [...new Set(normalized)];
};
exports.normalizeTags = normalizeTags;
//# sourceMappingURL=tagUtils.js.map